import { post } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';

import {
    setCustomerAcceptOddsFlag,
} from '~shared/utils/user';

export const updateAcceptOddsFlag = (flag) => {
    const url = buildSpectateUrl('/oddsacceptrequest/update');
    const requestParams = {
        accept_odds_change: flag,
    };

    post(url, requestParams).then(response => {
        if (response.ok) {
            setCustomerAcceptOddsFlag(flag);
        }
    });
};
